import axios from 'axios';
import { addResumenData, setIdResumen } from '../globalslice';
import getTransferInfo from '../services/TransferInfo';
import getDomainPrices from './PriceDomain';

// Función para obtener información del producto por ID
const getFeedCart = async (resumenData, dispatch, idResumen, currency) => {
  try {
    const feedCartUrl = process.env.REACT_APP_FEED_CART_URL;
    const response = await axios.get(feedCartUrl, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      withCredentials: true,
    });
    console.log("DATA")
    console.log(typeof(response.data))
    // const responseData = '({"elementos":1,"dominios":[{"type":"register","domain":"unhostingporahi.com","regperiod":"1","eppcode":null,"isPremium":false}]})';
    // const responseData = '({"elementos":2,"dominios":[{"type":"register","domain":"unhostingporahi.com.mx","regperiod":"1","eppcode":null,"isPremium":false},{"type":"transfer","domain":"dominiogratis.com","regperiod":"1","eppcode":null,"isPremium":false}]})'
    const responseData = response.data
    // Elimina los paréntesis adicionales si están presentes
    const cleanData = responseData.replace(/^\(/, '').replace(/\)$/, '');
    // Convierte el string limpio en un objeto JSON
    const jsonData = JSON.parse(cleanData);
    console.log(jsonData)
    //loop de dominios
    verifyDomains(resumenData, jsonData, dispatch, idResumen, currency);
   
    return jsonData;
  } catch (error) {
    throw error;
  }
};

// Función para verificar dominios
const verifyDomains = async (resumenData, responseData, dispatch, idResumen, currency) => {
  console.log("Verificando dominios...");

  try {
    if (!Array.isArray(responseData.dominios)) {
      throw new Error('La propiedad "dominios" no es un arreglo');
    }

    // Usamos for...of para soportar async/await correctamente
    for (const responseDomain of responseData.dominios) {
      if (!responseDomain.domain) {
        console.error('Dominio no válido:', responseDomain);
        continue;
      }

      const exists = resumenData.some(item =>
        item.product?.domain_section?.some(section =>
          section.dominio_principal === responseDomain.domain
        )
      );

      if (exists) {
        console.log("Ya existe el dominio: " + responseDomain.domain);
      } else {
        console.log("Agrega el dominio: " + responseDomain.domain);
        let name = 'Registro de dominio'
        let smallname = 'Registro de dominio'
        const dominio = responseDomain.domain
        let resDomain = null
        let cost = 0
        let second_price = 0
        let cross_price = false
        let selectPeriods = []
        let data = {}
        let regperiod = responseDomain.regperiod
        let indexFeedW = responseData.dominios.findIndex(domain => domain.domain === responseDomain.domain);
        console.log("indexFeedW")
        console.log(indexFeedW)
        if(responseDomain.type == 'transfer') {
          name = 'Transferencia de Dominio'
          smallname = 'Transferencia de Dominio'
          resDomain = await getTransferInfo({ dominioTransferencia: dominio, withHosting: false });

          if (resDomain.success === 'success') {
            if(resDomain.classerror == 'green'){
              cost = resDomain.data.Descuento
              second_price = resDomain.data.Precio

              data = {
                product: {
                  name: name,
                  smallname: smallname,
                  description: ``,
                  domain_section: [
                    {
                      'dominio_principal': dominio,
                      domain_type: responseDomain.type
                    }
                  ],
                  privacy_protection: false
                },
                price:{
                  cost: cost,
                  second_price: second_price, //precio real
                  cross_price: cross_price
                },
                periodo: '1 año (s)',
                id: idResumen,
                actual : false,
                type: 'domain',
                selectPeriods: selectPeriods
              }
            }
          }
        } else {
          if(responseDomain.type == 'register') {
            name = 'Registro de dominio'
            smallname = 'Registro de dominio'
            const domainPriceSin = await getDomainPrices({ domain: dominio, currency: currency, type: 'solo', typeDomainRegister: 'register' });
            const privacy_protection = domainPriceSin.protection[0].protectionid
            const selectPeriods = domainPriceSin.precio.reduce((acc, item, index) => {
            const periodo = item.periodo;
              acc[periodo] = {
                  cost: item.costo,
                  cross_price: false,
                  second_price: item.preciomostrado
              };
              return acc;
            }, {});
            const cost = selectPeriods[regperiod]?.cost || null;
            const second_price = selectPeriods[regperiod]?.second_price || null;
            // const indexFeedW = res.data.indexFeedW

            console.log(JSON.stringify(domainPriceSin))
            if(domainPriceSin.success == 'success'){
              data = {
                product: {
                name: name,
                smallname: smallname,
                description: ``,
                domain_section: [
                    {
                    'dominio_principal': dominio,
                    domain_type: responseDomain.type
                    }
                ],
                ...({ privacy_protection:  privacy_protection})
                },
                price:{
                cost: cost,
                second_price: second_price,
                cross_price: false,
                ...{ privacy_cost: domainPriceSin.protection[0].protectionprice },
                ...{ privacy_period: regperiod + ' año (s)' },
                ...{ default_privacy_cost: domainPriceSin.protection[0].protectionprice}
                },
                periodo: regperiod + ' año (s)', //Valor por default del select
                id: idResumen,
                indexFeedW: indexFeedW,
                actual : false,
                type: 'domain',
                selectPeriods: selectPeriods,
                selectPeriodsWithout: selectPeriods
            }
          }
            
          }
        }
        console.log("resDomain")
        // console.log(JSON.stringify(resDomain))
        console.log(JSON.stringify(data))

        dispatch(addResumenData(data));
        dispatch(setIdResumen());
      }
    }
  } catch (error) {
    console.error("Error verificando los dominios:", error);
  }
};

export default getFeedCart;
